import { useEffect, useMemo } from 'react'

import { useAuth } from '../useAuth/useAuth'
import { useQuery } from '../useQuery/useQuery'
import { useLogger } from '../useLogger/useLogger'

import {
  getAccountConfigFromAuthState,
  getPartnerFromAuthState
} from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'
import { donationSummary } from '@percent/workplace-giving/api/account/donationSummary/donationSummary'

export const useDonationSummaryFiscalPeriod = () => {
  const { state: authState } = useAuth()
  const accountConfig = getAccountConfigFromAuthState(authState)
  const partner = getPartnerFromAuthState(authState)
  const { logError } = useLogger()

  const currencyCode = accountConfig?.currency ?? partner?.currencyCode

  const fiscalYearDates = useMemo(() => {
    if (authState.status === 'authorized' && authState.datePeriod.currentPeriodStarted) {
      return {
        startDate: authState.datePeriod.currentPeriodStarted
      }
    }

    return {}
  }, [authState])

  const donationSummaryData = useQuery(
    ['donationSummary', { currencyCode: currencyCode!, ...fiscalYearDates }],
    donationSummary,
    {
      enabled: authState.status === 'authorized' && !!currencyCode,
      staleTime: 1000 * 20
    }
  )

  useEffect(() => {
    if (donationSummaryData?.error) {
      logError(donationSummaryData.error)
    }
  }, [donationSummaryData?.error, logError])

  return donationSummaryData
}
